const EditUserConstants = {
  GLOBAL: "global",

  SETDATAUSER_TYPE: "AGREGAR",
  
};
export default EditUserConstants;